import { AfterViewInit, Component, ElementRef, ViewChildren, QueryList, ViewEncapsulation } from '@angular/core';
import { Capability } from 'src/app/modules/common/_types/capability';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { TransactionLine } from '../../_types/transaction-line';
import { TransactionsLinesService } from '../../_services/transactions-lines.service';
import { Rate } from 'src/app/modules/rates/_types/rate';
import { RatesService } from 'src/app/modules/rates/_services/rates.service';
import { RateLine } from 'src/app/modules/rates/_types/rate-line';
import { TransactionsService } from '../../_services/transactions.service';
import { Tax } from 'src/app/modules/taxes/_types/tax';
import { TaxesService } from 'src/app/modules/taxes/_services/taxes.service';
import { TransactionLineTemplate } from '../../_types/transaction-line-template';
import { TransactionsLinesTemplatesService } from '../../_services/transactions-lines-templates.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { StringUtilsService } from 'src/app/core/services/string-utils.service';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { File } from 'src/app/modules/common/_types/file';
import { TransactionsFilesService } from '../../_services/transactions-files.service';
import { TransactionFile } from '../../_types/transaction-file';

@Component({
    selector: 'app-transaction-line',
    templateUrl: './transaction-line.component.html',
    styleUrls: ['./transaction-line.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransactionLinesComponent implements AfterViewInit {
  public transactionLineFormGroup!: RxFormGroup;
  public transactionLine: TransactionLine = new TransactionLine();
  public transaction: any = {};
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public loadingRates: boolean = false;
  public taxes: Tax[] = [];
  public loadingTaxes: boolean = false;
  public isRate: boolean = false;

  public allRates: Rate[] = [];
  public allCapabilities: Capability[] = [];
  public capabilities: Capability[] = [];
  public selectedCapability: string | undefined;

  public transactionLineTemplates: TransactionLineTemplate[] = [];
  public templateConfig: any = {
    fields: []
  };
  public templateLineData: any = {};

  public rateLines: RateLine[] = [];
  public allRateLines: any;

  public type!: string;

  public rateLineSelected: any = {
    freePrice: true
  };
  public uploadDocument: boolean = false;
  public files: any[] = [];

  @ViewChildren('autoGrowTextarea') autoGrowTextareas!: QueryList<ElementRef<HTMLTextAreaElement>>;

  constructor(
    private transactionLinesService: TransactionsLinesService,
    private transactionsService: TransactionsService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private formBuilder: RxFormBuilder,
    public formValidationService: FormValidatorService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ratesService: RatesService,
    private taxesService: TaxesService,
    private capabilitiesService: CapabilitiesService,
    private transactionLineTemplatesService: TransactionsLinesTemplatesService,
    private loginService:LoginService,
    public stringUtilsService: StringUtilsService,
        private filesService: FilesService,
        private transactionsFilesService: TransactionsFilesService
  ) {

    this.transactionLineFormGroup = this.formBuilder.formGroup(TransactionLine) as RxFormGroup;
  }

  async ngOnInit() {

    //this.loadRates();
    await this.loadTaxes();    
    await this.loadTransaction(this.config.data.transactionId);
    await this.loadCapabilities();
    await this.loadRates();
    await this.loadTransactionLineTemplates();
    
    this.uploadDocument = this.config.data.uploadDocument;

    this.type = this.config.data.type;
    let transactionLineId = this.config.data.transactionLineId;
    let isGroup = this.config.data.isGroup;
    let selectedCapabilityId = this.config.data.selectedCapability;
    
    
    if (transactionLineId) {
      await this.loadTransactionLine(transactionLineId);      
    } else {
      this.transactionLine.transactionId = this.config.data.transactionId;
      if(isNaN(this.config.data.lineNumber)){
        this.transactionLine.lineNumber = 1;
      }else{
        this.transactionLine.lineNumber = this.config.data.lineNumber;
      }
            
      this.transactionLine.isGroup = isGroup;
      if(this.isRate){
        //si es presupuesto de cliente/afectado, hay que poner el IVA reducido
        if(this.type == "outgoing_budget" || this.type == "affected_outgoing_budget"){ 
          //TODO: Añadir un campo code...
          this.transactionLine.taxPercent = this.taxes.filter(m => m.code == "REDUCED")[  0].percent;    

        }else{
          this.transactionLine.taxPercent = this.taxes.filter(m => m.default)[0].percent;        
        }    
        await this.loadRateLines();        
      }  
      this.transactionLineFormGroup.patchValue(this.transactionLine);
    }

    this.allowWrite = this.loginService.hasPermission(this.type.toUpperCase() + ".WRITE");
    this.allowDelete = this.loginService.hasPermission(this.type.toUpperCase() + ".DELETE");
    
    //Si le llega el capability, que se lo ponga.
    if(selectedCapabilityId){
      
      this.selectedCapability = selectedCapabilityId;
      this.selectCapability({
        value: this.selectedCapability
      }); 
    }

    this.scheduleResizeTextareas();

  }

  ngAfterViewInit(): void {
    this.autoGrowTextareas.changes.subscribe(() => this.scheduleResizeTextareas());
    this.scheduleResizeTextareas();
  }

  async loadTransactionLineTemplates() {
    let filter = {
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transaction.transactionTypeId)
    };
    let params: IParamsCollection = {
      sort: ['name'],
      page: {
        size: 100
      },
      filter: FilterBuilder.fromObject(filter).build()
    }
    let response = await firstValueFrom(this.transactionLineTemplatesService.all(params));
    this.transactionLineTemplates = response.data;
  }


  async loadCapabilities() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: {
        size: 1000
      }
    }
    let response = await firstValueFrom(this.capabilitiesService.all(params));
    this.allCapabilities = response.data;
  }

  async loadRates() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: {
        size: 1000
      }
    }
    let response = await firstValueFrom(this.ratesService.all(params));
    this.allRates = response.data;
  }

  async loadTransaction(transactionId: string){

    let paramsTransaction: IParamsCollection = {
      
    }
    
    paramsTransaction.include = ['transactionType', 'case.clientPolicy'];
    this.transaction = await firstValueFrom(this.transactionsService.get(transactionId, paramsTransaction));    

    this.isRate = this.transaction.transactionType.enableRate;
    
  }

  async loadTransactionLine(transactionLineId: string) {

    if(this.isRate){            
      await this.loadRateLines();        
    }  

    let params: IParamsCollection = {
      
    }

    if(this.isRate){
      params.include = ['rateLine'];
    }
    this.transactionLine = await firstValueFrom(this.transactionLinesService.get(transactionLineId, params));
    
    if (this.isRate) {      
      if (this.transactionLine.rateLine) {
        await this.loadRateLines();        
        this.selectedCapability = this.transactionLine.rateLine.capabilityId;        
        this.selectCapability({
          value: this.selectedCapability
        });        
      }
    }

    this.transactionLineFormGroup.patchValue(this.transactionLine);

    //si el baremo de la línea no es de precio libre, bloqueamos el precio al abrir.
    this.applyRateLinePriceLock();

    //seleccionamos tipo de plantilla si hay
    if(this.transactionLine.transactionLineTemplateId){
      this.selectTransactionLineTemplate({ value: this.transactionLine.transactionLineTemplateId });
    }

    //cargamos datos de plantilla si hay
    if(this.transactionLine.templateLineData){
      this.templateLineData = JSON.parse(this.transactionLine.templateLineData);
    }

    this.scheduleResizeTextareas();

  }

  async loadRateLines() {    

    var thirdPartyId = this.transaction.thirdPartyId;
    let typeStr = "COMPANY";
    if(this.type == "incoming_invoice") typeStr = "WORKER";
    if(this.type == "ingoing_budget_worker") typeStr = "WORKER";
    if(this.type == "outgoing_budget" || this.type == "affected_outgoing_budget"){
      //si es un presupuesto a cliente/afectado, hay que poner los baremos de la compañía del cliente/afectado
      thirdPartyId = this.transaction.case.companyId;
    }
    
    this.allRateLines = await firstValueFrom(this.ratesService.rateLinesCompany(typeStr, thirdPartyId, this.transaction.date, this.transaction.case?.clientPolicy?.insuranceCompanyId, this.transaction.case?.contractId,false ));   
    /*this.capabilities = this.allRateLines.map((m: any) => m.capability).filter((capability: any, index: any, self: any) =>
      index === self.findIndex((p: any) => p.id === capability.id)
    );*/
    let capabilityIds = [...new Set(this.allRateLines.map((m: any) => m.capabilityId))];
    this.capabilities = this.allCapabilities.filter((m: any) => capabilityIds.includes(m.id));

  }

  getRate(id: string): Rate | undefined {
    return this.allRates.find((m: Rate) => m.id == id);
  }

  selectCapability(capability: any) {    
    this.rateLines = this.allRateLines.filter((m: any) => m.capabilityId == capability.value)
    this.rateLines.forEach((rateLine) => {
      rateLine.displayName = rateLine.code + (rateLine.description != null && rateLine.description != "" ? " - " + rateLine.description : "");
    });    
    if (this.transactionLine.rateLineId != null) {
      this.rateLineSelected = this.allRateLines.find((m: any) => m.id == this.transactionLine.rateLineId);
    }

  }

  selectRateLine(e: any) {
    this.transactionLine.price = this.rateLines.find((rl: any) => rl.id == e.value)?.price || 0;
    this.transactionLineFormGroup.patchValue({ unitPrice: this.transactionLine.price });
  }

  selectTransactionLineTemplate(e: any) {
    let template = this.transactionLineTemplates.find((m: any) => m.id == e.value);
    this.templateConfig = { fields: [] };
    if(template){
      this.templateConfig = template.configuration ? JSON.parse(template.configuration) : {};
    }
    this.scheduleResizeTextareas();
  }

  public scheduleResizeTextareas(): void {
    setTimeout(() => this.resizeAllTextareas(), 0);
  }

  private resizeAllTextareas(maxHeight: number = 220): void {
    if (!this.autoGrowTextareas) {
      return;
    }

    this.autoGrowTextareas.forEach((textareaRef) => {
      const textarea = textareaRef.nativeElement;
      this.stringUtilsService.ResizeTextareaElement(textarea, maxHeight);
    });
  }

  async loadTaxes() {
    this.loadingTaxes = true;
    let params: IParamsCollection = {
    }

    let response = await firstValueFrom(this.taxesService.all(params));
    this.taxes = response.data;

    this.loadingTaxes = false;
  }

  calculatePricePurchaseOrder(event: any){
    const precioTotalSinDescuento = this.transactionLineFormGroup.value.quantity * this.transactionLineFormGroup.controls["price"].value;
    let precioConDescuentoAument = precioTotalSinDescuento;
    if(this.transactionLineFormGroup.value.discountAmount != null && this.transactionLineFormGroup.value.discountAmount > 0){
      precioConDescuentoAument = precioTotalSinDescuento - this.transactionLineFormGroup.value.discountAmount;  
    }
    let impuesto = 0;
            
    const precioFinal = parseFloat(precioConDescuentoAument.toFixed(2));
    this.transactionLineFormGroup.controls["subtotal"].setValue(precioFinal);
  }

  calculatePrices(event: any) {        
    const precioTotalSinDescuento = this.transactionLineFormGroup.value.quantity * this.transactionLineFormGroup.controls["price"].value;
    let precioConDescuentoAument = precioTotalSinDescuento;

    if(this.transaction.transactionType.enableDiscount && this.transactionLineFormGroup.value.discountPercent != null && this.transactionLineFormGroup.value.discountPercent > 0){
      let descuento = precioTotalSinDescuento * (this.transactionLineFormGroup.value.discountPercent / 100);
      descuento = parseFloat(descuento.toFixed(2));
      this.transactionLineFormGroup.controls["discountAmount"].setValue(descuento);
      precioConDescuentoAument = precioTotalSinDescuento - descuento;      
      
      this.transactionLineFormGroup.get('incrementAmount')?.disable();
    }else{      
      this.transactionLineFormGroup.controls["discountAmount"].setValue(null);
      this.transactionLineFormGroup.get('incrementAmount')?.enable();
    }


    if(this.transaction.transactionType.enableDiscount && this.transactionLineFormGroup.value.incrementPercent != null && this.transactionLineFormGroup.value.incrementPercent > 0){
      let incremento = precioTotalSinDescuento * (this.transactionLineFormGroup.value.incrementPercent / 100);
      incremento = parseFloat(incremento.toFixed(2));
      this.transactionLineFormGroup.controls["incrementAmount"].setValue(incremento);
      precioConDescuentoAument = precioTotalSinDescuento + incremento;
      this.transactionLineFormGroup.get('discountAmount')?.disable();
    } 
    else
    {  
      this.transactionLineFormGroup.controls["incrementAmount"].setValue(null);
      this.transactionLineFormGroup.get('discountAmount')?.enable();

    }
        
    let impuesto = 0;
    
    if(this.transaction.transactionType.enableTax){
      impuesto = precioConDescuentoAument * (this.transactionLineFormGroup.value.taxPercent / 100);
      this.transactionLineFormGroup.controls["taxAmount"].setValue(impuesto);
    }
        
    const precioFinal = parseFloat(precioConDescuentoAument.toFixed(2));
    this.transactionLineFormGroup.controls["subtotal"].setValue(precioFinal);
    
  }


  async save() {
    
    
    let valid = this.formValidationService.validateForm(this.transactionLineFormGroup);
    if (valid) {
      this.transactionLine = Object.assign(this.transactionLine, this.transactionLineFormGroup.getRawValue());

      //si tiene que subir un documento:
      if(this.uploadDocument){
        var message = "";
        if(this.transactionLine.quantity == null || this.transactionLine.price == null || this.transactionLine.taxPercent == null || this.files.length == 0){
           message =  "Debe añadir al menos un producto y seleccionar un archivo.\n";
        }
        if(message != ""){
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: message });
          return;
        }
  
        if (this.files.length > 0) {
          try {
            for (let file of this.files) {
              let data: File = new File();
              data.fileName = file.name;
              data.size = file.size;
              data.contentType = file.type;
              //data.path = file.name;
    
              //creamos el file
              let fileResponse = await firstValueFrom(this.filesService.save(data));
    
              //subimos el fichero al file
              let response = await firstValueFrom(this.filesService.upload(fileResponse.id as string, file));
    
              //guardamos el file en el expediente
              let transactionFile : TransactionFile = new TransactionFile();
              transactionFile.fileId = fileResponse.id as string;
              transactionFile.transactionId = this.transactionLine.transactionId;
              await firstValueFrom(this.transactionsFilesService.save(transactionFile));
            }
          } catch (error) {
            this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Error al guardar los ficheros." });
          }
        } 
        
      }

      this.transactionLine.templateLineData = JSON.stringify(this.templateLineData);
      let transactionLine = await firstValueFrom(this.transactionLinesService.save(this.transactionLine));
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Línea guardada correctamente." });
      this.dynamicDialogRef.close({id: this.transactionLine.id ? null : transactionLine.id, selectedCapability: this.selectedCapability}); 
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la línea de transacción?",
      header: "Eliminar línea",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.transactionLinesService.delete(this.transactionLine.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Línea eliminada correctamente." });
            this.cancel();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.dynamicDialogRef.close();
  }  


  // Bloquea el precio si el baremo seleccionado no es de precio libre (freePrice == false).
  // Se usa tanto al cambiar el baremo como al cargar una línea existente.
  private applyRateLinePriceLock() {
    if(this.rateLineSelected != null && !this.rateLineSelected.freePrice){
      this.transactionLineFormGroup.get('price')?.disable();
    }else{
      this.transactionLineFormGroup.get('price')?.enable();
    }
  }

  // Asignar el precio unitario de la línea de tarifa al cambiar la línea de tarifa
  onRateLineChange(e: any) {
    this.rateLineSelected = this.allRateLines.find((rateLine: any) => rateLine.id == e.value);
    this.transactionLineFormGroup.controls['price'].setValue(this.rateLineSelected?.price || 0);
    this.applyRateLinePriceLock();
    if(this.rateLineSelected.fixedAmount != null){
      this.transactionLineFormGroup.controls['quantity'].setValue(this.rateLineSelected.fixedAmount);
      this.transactionLineFormGroup.get('quantity')?.disable();
    }else{
      this.transactionLineFormGroup.controls['quantity'].setValue(1);
      this.transactionLineFormGroup.get('quantity')?.enable();
    }

    this.calculatePrices(e);
  }


  async onFileSelect(event: any) {
    let files = event.files;
    for (let file of files) {
      this.files.push(file);
    }
  }

}
